<template>
  <v-form v-model="valid" dark ref="form">
    <div>
        <v-row>
          <v-col cols="24">
            <v-text-field
              v-model="inputs.name"
              :rules="rules.nameRules"
              label="Name"
              dark
              required
              :disabled="isProcessing"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="24">
            <v-text-field
              v-model="inputs.phone"
              :rules="rules.phoneRules"
              label="Phone"
              dark
              required
              :disabled="isProcessing"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="24">
            <v-text-field
              v-model="inputs.email"
              :rules="rules.emailRules"
              label="E-mail"
              dark
              required
              :disabled="isProcessing"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" sm="6">
            <v-select
              v-model="inputs.hairLength"
              :items="hairLength"
              label="Hair Length"
              append-icon="keyboard_arrow_down"
              dark
              :rules="rules.selectHairLengthRules"
              required
              :disabled="isProcessing"
            ></v-select>
          </v-col>
          <v-col cols="12" sm="6">
            <v-select
              v-model="inputs.specialConsiderations"
              :items="specialConsiderations"
              label="Special Considerations"
              append-icon="keyboard_arrow_down"
              dark
              :rules="rules.selectSpecialConsiderationsRules"
              required
              :disabled="isProcessing"
            ></v-select>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="6">
            <v-file-input
              v-model="inputs.photos"
              @change="selectedPhotos"
              dark
              multiple
              chips
              placeholder="Upload Your Photo"
              accept="image/png, image/jpeg, image/jpg, image/bmp"
              outlined
              prepend-icon=""
              prepend-inner-icon="photo_camera"
              class="gh-upload"
              :disabled="isProcessing"
            >
              <template v-slot:selection="{ index, text }">
                <v-chip
                  v-if="index < 2"
                  color="#555"
                  dark
                  label
                  small
                >
                  {{ text }}
                </v-chip>
                <span
                    v-else-if="index === 2"
                    class="overline text--darken-3 mx-2"
                  >
                    +{{ inputs.photos.length - 2 }} File(s)
                  </span>
              </template>
            </v-file-input>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="24">
            <button class="gh-button" @click.prevent="handleSubmit">
              <v-progress-circular
                v-if="isProcessing"
                indeterminate
                color="primary"
              ></v-progress-circular>
              {{ buttonText }}
            </button>
          </v-col>
        </v-row>
    </div>
     <gh-dialog-alert
      v-if="openDialog"
      :title="dialogTitle"
      :message="dialogMessage"
      :is-open="openDialog"
      :type="dialogType"
      @close="closeDialog"></gh-dialog-alert>
  </v-form>
</template>

<script>

import { format } from 'date-fns'
import mixinForm from './mixins/form'
import ghDialogAlert from '../dialog/dialog-alert'

  export default {
    name: 'ghFormModels',

    mixins: [mixinForm],

    components: {
      ghDialogAlert
    },

    props: {
      hairLength: {
        type: Array,
        required: true
      },
      specialConsiderations: {
        type: Array,
        required: true
      }
    },

    data () {
      return {
        valid: false,
        isProcessing: false,
        openDialog: false,
        dialogTitle: '',
        dialogMessage: '',
        dialogType: 'success',
        isSuccess: false,
        inputs: {
          name: '',
          phone: '',
          email: '',
          hairLength: '',
          specialConsiderations: '',
          photos: []
        },
        rules: {
          selectHairLengthRules: [
            v => !!v || 'Field is required'
          ],
          selectSpecialConsiderationsRules: [
            v => !!v || 'Field is required'
          ],
          phoneRules: [
            v => !!v || 'Name is required'
          ],
          nameRules: [
            v => !!v || 'Name is required'
          ],
          emailRules: [
            v => !!v || 'E-mail is required',
            v => /.+@.+/.test(v) || 'E-mail must be valid',
          ]
        }
      }
    },

   computed: {
      buttonText() {
        return this.isProcessing ? 'Submitting' : 'SUBMIT'
      }
    },

    methods: {
      selectedPhotos(selected) {
        this.inputs.photos = selected
      },
      closeDialog () {
        if(this.isSuccess) {
          window.location.href = '/models'
        } else {
          this.openDialog = false
        }
      },

      async processForm () {
        this.isProcessing = true

        try {
          const formData = new FormData()
          this.isSuccess = false

          formData.append('name', this.inputs.name)
          formData.append('phone', this.inputs.phone)
          formData.append('email', this.inputs.email)
          formData.append('hair_length', this.inputs.hairLength)
          formData.append('special_considerations', this.inputs.specialConsiderations)

          for( var i = 0; i < this.inputs.photos.length; i++ ){
            let photo = this.inputs.photos[i];

            formData.append('photos[' + i + ']', photo);
          }

          await this.$http.post('/contact/models', formData)
            .then(res => {
              this.dialogType = 'success'
              this.dialogMessage = 'Thank you for your request, the form has been successfully submitted'
              this.dialogTitle = 'Request Sent'
              this.isSuccess = true
            }).catch(err => {
              if (err.response) {
                if(err.response.data.errors.email) {
                  this.dialogMessage = err.response.data.errors.email[0]
                }
              } else {
                this.dialogMessage = 'Something went wrong. Our service is not available at the moment.'
              }
              this.dialogType = 'error'
              this.dialogTitle = 'Unable to send message'
            })
        } catch (error) {
          this.dialogType = 'error'
          this.dialogTitle = 'Unable to send message'
          this.dialogMessage = 'Something went wrong. Our service is not available at the moment.'
        }

        this.openDialog = true
        this.isProcessing = false
      }
    }
  }
</script>

<style scoped lang="sass">
  .gh-button
    width: 200px
    background: inherit
    color: white

  .v-file-input
   .v-icon
      color: hsla(0,0%,100%,.7)

  .v-text-field
    padding-top: 0

  .gh-upload
    cursor: pointer

  .v-progress-circular
    margin-right: 1rem
</style>
